import React from "react";
import { makeStyles } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { Divider } from "@material-ui/core";
import { Typography } from '@material-ui/core';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
  } from "@mui/material";

const useStyles = makeStyles((theme) => ({
    container:{
        border: '3px solid #e0e0e0',
        borderRadius: '5px',
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5)
    },
    description:{
        whiteSpace: 'pre-line',
        marginBottom: theme.spacing(3),
    },
    divider:{
    },
    root:{
        [theme.breakpoints.up('xs')]:{
            margin: theme.spacing(1,1,15,1)
        },
        [theme.breakpoints.up('sm')]:{
            margin:theme.spacing(2,2,15,2)
        },
        [theme.breakpoints.up('md')]:{
            margin: theme.spacing(3,15,15,15)
        }
    },
    subtitle:{
        fontWeight: 'bold',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        fontSize: '16px'
    },
    table_body:{
        marginBottom: theme.spacing(3)
    },
    title:{
        fontWeight:'bold',
        textAlign:'center',
        marginTop: theme.spacing(10),
        marginBottom: theme.spacing(5)
    }
}))

function CompensationScreen(){
    const classes = useStyles()

    const rows = [
        {
          detail: "インク・化粧品・食べ物等による複数に渡るシミ,または5cmを超えるシミ",
          cost: "1000円",
        },
        {
          detail: "血液・排泄物等のクリーニング不可能なシミ、漂白剤などによる色落ち",
          cost: "買取、アイテムの購入価格を参照",
        },
        {
          detail: "生地の目に沿わない破れ・破れ",
          cost: "買取、アイテムの購入価格を参照",
        },
        {
          detail: "経年劣化以外が牽引によるファスナーの不良・壊れ",
          cost: "ブランドオリジナルの場合は買取、変えが可能なものに関してはパーツ料金分の請求",
        },
        {
          detail: "ボタンの外れ（装飾品紛失あり）",
          cost: "なし",
        },
        {
          detail: "ボタンの外れ（装飾品紛失なし）",
          cost: "ブランドオリジナルの場合は買取、変えが可能なものに関してはパーツ料金分の請求",
        },
        {
          detail: "不適切なアイロンの使用による損傷、焦げ・剥げ・焦黒・圧縮跡など",
          cost: "買取、アイテムの購入価格を参照",
        },
        {
          detail: "返却をせず、アイテムの紛失",
          cost: "買取、アイテムの購入価格を参照",
        },
        {
          detail: "パーツ欠品付属（アクセサリー含む）、留め具、チェーン、カン類の外れ",
          cost: "ブランドオリジナルのパーツの場合は買取、変えが可能なものに関してはパーツ料金分の請求",
        },
      ];    

    return(
        <div className={classes.root}>
            <Typography variant="h1" component="h1" align="center" className={classes.title}>
                汚破損時について
            </Typography>
            <Typography variant="p" component="p" className={classes.description}>
                {`                
                Enclopediaでは、通常の着用範囲内の汚破損であれば、クリーニング・修繕費用はレンタル料金、サブスクリプション料金に含まれておりますので、ご安心ください。\n
                但し、クリーニングや修繕作業にて特殊な処理が必要な汚破損や、次の方がご利用いただけないような状態の場合には別途修繕費や買取りを価格表に基づいてお願いさせていただく場合がございます。\n
                大きな汚破損や付属品の紛失などトラブルが発生した場合は、お問い合わせ、メール、LINEから状況をお知らせください。
                `}
            </Typography>
            <Container className={classes.container} maxWidth="md">
                <Typography variant="h2" component="h2" align="center" className={classes.subtitle}>
                    《通常の着用範囲内の汚破損例》
                </Typography>
                <Typography variant="p" component="p" className={classes.description}>
                    {`                
                    ・飲食物、化粧品、文房具等における小さなシミ・汚れ\n
                    ・生地のほつれ（破れ・裂け、引っかかりによるほつれは除く）\n
                    ・ボタン、ホックなどの縫い付けられた物の外れ（外れたパーツは同梱の上返却ください）\n
                    ・経年劣化によるシワ、くすみ、スレ\n
                    ・主にバッグにおける持ち手、洋服との摩擦による軽度な黒ずみ汚れ\n
                    `}
                </Typography>
                <Divider classes={{root:classes.divider}}/>
                <Typography variant="h2" component="h2" align="center" className={classes.subtitle}>
                    《通常の着用範囲を超える汚破損例》
                </Typography>
                <Typography variant="p" component="p" className={classes.description}>
                    {`                
                    ・付属品の紛失\n
                    ・血液や排泄物といった感染の可能性のあるシミ\n
                    ・染料が移染した汚れや、広範囲の雨染みによる変色\n
                    ・破れ・裂け、引っかかりによる大きなほつれ\n
                    ・5cmを超えたり、シミが小さい場合にも複数にわたる飲食物、化粧品等におけるシミ・汚れ(首周り、手首など通常使用による皮脂汚れの場合、通常の着用範囲を超える汚れには含まれません)\n
                    ・タバコ、香水、柔軟剤等による過度の着臭\n
                    ・自転車の巻き込みによる破れ・アクセサリー、バッグ等の引っかかりによる糸つれ\n
                    `}
                </Typography>
            </Container>
            <Container maxWidth="md" className={classes.container}>
                <Typography variant="h2" component="h2" align="center" className={classes.subtitle}>
                    《買取、または修繕費》
                </Typography>
                    <Table className={classes.table_container}>
                        <TableHead>
                            <TableRow>
                                <TableCell>内容</TableCell>
                                <TableCell>買取、修理費</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className={classes.table_body}>
                            {rows.map((row, index) => (
                                <TableRow key={index}>
                                <TableCell>
                                    {row.detail}
                                </TableCell>
                                <TableCell>{row.cost}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
            </Container>
        </div>
    )
}

export default CompensationScreen